import YAML from 'yaml';

export const formatJson = (input) => {
  const trimmed = input?.trim();
  if (!trimmed) {
    return '';
  }

  try {
    const parsed = JSON.parse(trimmed);
    return JSON.stringify(parsed, null, 2);
  } catch (error) {
    throw new Error(`JSON inválido: ${error.message}`);
  }
};

const collapseWhitespaceBetweenTags = (xml) =>
  xml
    .replace(/\r\n/g, '\n')
    .replace(/>\s+</g, '><')
    .trim();

export const formatXml = (input) => {
  const trimmed = input?.trim();
  if (!trimmed) {
    return '';
  }

  const normalized = collapseWhitespaceBetweenTags(trimmed);
  const tokens = normalized
    .replace(/</g, '\n<')
    .split('\n')
    .map((token) => token.trim())
    .filter(Boolean);

  let indent = 0;
  const indentUnit = '  ';

  const formatted = tokens
    .map((token) => {
      if (token.startsWith('<?') || token.startsWith('<!')) {
        return `${indentUnit.repeat(indent)}${token}`;
      }

      if (token.startsWith('</')) {
        indent = Math.max(indent - 1, 0);
      }

      const line = `${indentUnit.repeat(indent)}${token}`;

      if (
        /^<[^/!][^>]*[^/]?>$/.test(token) &&
        !token.startsWith('<!') &&
        !token.endsWith('-->')
      ) {
        indent += 1;
      }

      return line;
    })
    .join('\n');

  return formatted;
};

export const formatYaml = (input) => {
  const trimmed = input?.trim();
  if (!trimmed) {
    return '';
  }

  try {
    const parsed = YAML.parse(trimmed);
    return YAML.stringify(parsed);
  } catch (error) {
    throw new Error(`YAML inválido: ${error.message}`);
  }
};

const formatters = {
  formatJson,
  formatXml,
  formatYaml,
};

export default formatters;
